import React from 'react';

// Import required components
import { Heading, ProcessStep } from '../../../components';
import { process } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Process = () => { 

  return (
    <section className='process'>

      {/* Section heading */}
      <Heading title={'Our Process'} subTitle={'Excellence in Every Step'} />

      <Swiper

        modules={[Autoplay]} // Enable Autoplay feature
        spaceBetween={10} // Space between slides
        loop={true} // Enables Infinite Loop
        autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-scroll every 4 seconds

        // Responsive Breakpoints for Different Screen Sizes
        breakpoints={{
          450: { slidesPerView: 1 }, // 1 slide for small screens
          768: { slidesPerView: 2 }, // 2 slides for tablets
          1025: { slidesPerView: 3 }, // 3 slides for larger screens
        }}

      >
        
        {/* Map over the process array to render each step */}
        {process.map((step) => { 
          return (
            <SwiperSlide key={step.id}>

              {/* Render individual step component */}
              <ProcessStep step={step} />

            </SwiperSlide>
          );
        })}
      </Swiper>

    </section>
  )
}

export default Process;